/* eslint-disable */
import React, { useEffect, memo } from 'react'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { makeStyles, ThemeProvider, createTheme } from '@material-ui/core'
import { useAppSelector, useAppDispatch } from '../app/hooks/reduxHooks'
import { handleChange } from '../app/formSlice'

const styles = theme => ({
    root: {
        flexBasis: '50%',
        width: props => `${props.fullWidth ? 100 : 50}%`,
        marginBottom: '16px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            flexBasis: '100%',
            width: '100% !important'
        }
    },
    input: {
        border: '1px solid #807A7A',
        borderRadius: '6px',
        padding: '6px 12px',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '150%',
    },
    fontFamily: {
        fontFamily: 'Aktiv Grotesk !important',
        lineHeight: '21px',
        fontSize: '14px',
        fontWeight: '400',
    },
    span: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& div': {
            width: '100%'
        }
    },
    label: {
        margin: '0',
        fontSize: '12px',
        lineHeight: '130%',
        alignSelf: 'flex-start',
        fontFamily: 'Aktiv Grotesk',
        marginBottom: '.5rem',
        fontWeight: '400'
    },
    '@global': {
        '.MuiFormHelperText-root': {
            position: 'absolute',
            top: '-26px',
            right: '0',
            fontFamily: 'Aktiv Grotesk',
            fontWeight: '400',
            lineHeight: '1rem'
        }
    }
})

export const theme = createTheme({
    palette: {
        primary: {
            main: '#fff'
        }
    }
})

const useStyles = makeStyles(styles)

const addValidation = () => {
    ValidatorForm.addValidationRule('isText', value => {
        return /^[a-z '-]+$/i.test(value.toString().trim())
    })
    ValidatorForm.addValidationRule('isEmail', value => {
        return /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value.toString().trim())
    })
}

function TextInput({
    validationType,
    validate,
    label,
    fullWidth,
    name,
    placeholder,
    multiLine,
    validationMessage
}) {
    const props = {
        fullWidth
    }
    const preserveMultiline = { whiteSpace: 'pre-wrap' }
    const classes = useStyles(props)
    const value = useAppSelector(state => state.form[name])
    const dispatch = useAppDispatch()
    const setValue = e => {
        dispatch(handleChange({
            name: e.target.name,
            value: e.target.value
        }))
    }
    useEffect(() => {
        if (validate) addValidation()
    }, [])
    const validateOptions = validate ? ['required', validationType] : ['required']
    const validateMessages = validate ? ['Necessario', validationMessage] : ['Necessario']
    return (
        <div className={classes.root} >
            <ThemeProvider theme={theme}>
                <span className={classes.span} >
                    <p className={classes.label} >{label} *</p>
                    <TextValidator
                        multiline={multiLine}
                        style={multiLine ? preserveMultiline : {}}
                        name={name}
                        fullWidth
                        required
                        onChange={setValue}
                        value={value}
                        placeholder={placeholder}
                        rows={multiLine ? 5 : 1}
                        InputProps={{
                            disableUnderline: true,
                            className: classes.fontFamily
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                        className={classes.input}
                        validators={validateOptions}
                        errorMessages={validateMessages}
                    />
                </span>
            </ThemeProvider>
        </div>
    )
}

export default memo(TextInput)
